module.exports = __webpack_public_path__ + "statics/img/cate9-1@2x.aeca1b64.png";